import { KrogerCheckout } from '../../../data-products/index.js';
import { krogerConfig as config } from '../data/index.js';
import { getPotentialGAMClickTracker } from '../../../utils/index.js';
/**
 * `krogerCheckout` is the {@link ICheckoutService} for
 * the Kroger retailer integration
 */
const krogerCheckout = {
    config,
    /**
     * `checkout` executes the kroger-specific functionality to purchase products
     * @param {IRetailerCartItem[]} items - the {@link IRetailerCartItem} array of products to be purchased
     * @param {IRetailerLocation} location - the currently selected {@link IRetailerLocation}
     * @param {() => void} callbackFunction - OPTIONAL callback function
     * @returns {Promise<string>} A Promise resolving to the checkout URL
     */
    checkout: (krogerCheckoutServiceConfig) => {
        // TODO: handle default checkout here or outside?
        // if (this.isDefault) {
        //     window.open(this.cartUrl);
        // }
        // Convert items to KrogerItems
        const krogerItems = krogerCheckoutServiceConfig.selectedItems
            .filter((item) => item.upc !== '' && item.upc !== '000000000000')
            .map((i) => ({
            upc: i.upc,
            quantity: 1
        }));
        const kconfig = {
            retailerName: krogerCheckoutServiceConfig.location ? krogerCheckoutServiceConfig.location.chain : 'kroger',
            items: krogerItems,
            onCartCreated: (cartUrl) => {
                console.log('[KROGER AUTH] Success: User authenticated and cart created');
                if (krogerCheckoutServiceConfig.callbackFunction)
                    krogerCheckoutServiceConfig.callbackFunction();
            },
            onCartError: () => {
                console.error('[KROGER AUTH] Error: Failed to authenticate user');
            }
        };
        const kc = new KrogerCheckout(kconfig.retailerName, kconfig.items, kconfig.onCartCreated, kconfig.onCartError);
        return getKrogerCheckoutUrl(kc);
    }
};
const getKrogerCheckoutUrl = async (kc) => {
    const krogerCheckoutUrl = await kc.handleCheckoout();
    const gamRedirectUrl = getPotentialGAMClickTracker();
    let destinationUrl = krogerCheckoutUrl;
    if (window.location.hostname === 'localhost' && gamRedirectUrl) {
        // URI needs to be encoded on localHost ONLY for testing purposes
        destinationUrl = encodeURIComponent(destinationUrl);
    }
    const retailerCheckoutUrl = gamRedirectUrl ? `${gamRedirectUrl}${destinationUrl}` : destinationUrl;
    return retailerCheckoutUrl;
};
// const krogerAuth = {};
export default krogerCheckout;
